"use strict";

var _createForOfIteratorHelper = require("/var/www/prod/lucky1/lucky-one-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.traverseNode = traverseNode;

var _context = require("./context");

var _t = require("@babel/types");

var VISITOR_KEYS = _t.VISITOR_KEYS;

function traverseNode(node, opts, scope, state, path, skipKeys) {
  var keys = VISITOR_KEYS[node.type];
  if (!keys) return false;
  var context = new _context.default(scope, opts, state, path);

  var _iterator = _createForOfIteratorHelper(keys),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      if (skipKeys && skipKeys[key]) continue;

      if (context.visit(node, key)) {
        return true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return false;
}